import { getXLCenterContentMediaQuery } from '@modules/layout/layout/constants/layoutConstants';
import { makeStyles } from '@rbx/ui';

const useFooterStyles = makeStyles<{
  mainMaxWidth: number;
  isLandingPage?: boolean;
  hasRightNav?: boolean;
}>()((theme, { mainMaxWidth, isLandingPage, hasRightNav }) => {
  return {
    container: {
      maxWidth: `${mainMaxWidth}px !important`,
      paddingTop: 64,
      paddingBottom: 24,
      backgroundColor: theme.palette.surface[0],
      flexShrink: 0,
      justifyContent: isLandingPage || !hasRightNav ? 'center' : 'flex-start',
      margin: `0 auto ${isLandingPage ? '!important' : ''}`,
      [getXLCenterContentMediaQuery(mainMaxWidth)]: {
        margin: 0,
      },
    },

    sizeContainer: {
      containerType: 'inline-size',
    },
  };
});

export default useFooterStyles;
